import { useState } from 'react';

const useGridTransaction = (fetchData) => {
  const [rowData, setRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [newRowId, setNewRowId] = useState(1);
  const [rowTransaction, setRowTransaction] = useState({
    add: [],
    update: [],
    remove: []
  });

  // 행 추가 핸들러
  const handleAddRow = (columnDefs, gridRef) => {
    const newRowIdStr = `new-${newRowId}`;
    const newRow = {};
    columnDefs.forEach(col => {
      newRow[col.field] = '';
    });
    newRow.id = newRowIdStr;
  
    // 새 행 추가
    setRowData(prev => [newRow, ...prev]);
    
    // 트랜잭션에 추가
    setRowTransaction(prev => ({
      ...prev,
      add: [...prev.add, newRow]
    }));
    
    setNewRowId(prev => prev + 1);
    
    // 새 행 선택
    if (gridRef.current && gridRef.current.api) {
      setTimeout(() => {
        gridRef.current.api.forEachNode(node => {
          if (node.data.id === newRowIdStr) {
            node.setSelected(true);
          }
        });
      }, 100);
    }
  };

  // 행 삭제 핸들러
  const handleDeleteRow = async (axiosPrivate, endpoint, projectParams) => {
    if (selectedRows.length === 0) {
      alert("삭제할 행을 선택해주세요.");
      return;
    }

    try {
      // 서버에 삭제 요청
      await axiosPrivate.delete(endpoint, {
        data: { ids: selectedRows.map(row => row.id) }
      });
      
      // 트랜잭션에 삭제 추가
      setRowTransaction(prev => ({
        ...prev,
        remove: [...prev.remove, ...selectedRows]
      }));
      
      // 로컬 상태에서 삭제
      setRowData(prev => prev.filter(row => !selectedRows.some(selected => selected.id === row.id)));
      setSelectedRows([]);
      alert("삭제 완료!");
    } catch (err) {
      console.error("삭제 실패:", err);
      alert("데이터 삭제 중 오류가 발생했습니다.");
    }
  };

  // 행 저장 핸들러
  const handleSaveRow = async (axiosPrivate, endpoint, projectParams) => {
    // 저장할 행 구성 (트랜잭션 기반)
    const rowsToSave = [
      ...rowTransaction.add,
      ...rowTransaction.update
    ];
  
    // 예외처리
    if (rowsToSave.length === 0) {
      alert("저장할 변경사항이 없습니다.");
      return;
    }
  
    try {
      // 백엔드에 전송
      await axiosPrivate.post(endpoint, {
        rows: rowsToSave,
        ...projectParams
      });
  
      // 저장이 끝나면 다시 조회
      await fetchData();
      alert("변경사항이 저장되었습니다.");
    } catch (err) {
      console.error("저장 실패:", err);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  // 셀 값 변경 핸들러
  const onCellValueChanged = (params, validationFn) => {
    const { data, oldValue, newValue } = params;
    
    // 값이 변경되지 않았으면 무시
    if (oldValue === newValue) return;
    
    // 유효성 검사 함수가 있으면 실행
    if (validationFn && !validationFn(params)) {
      return;
    }
    
    // 트랜잭션에 업데이트 추가
    if (rowTransaction.add.some(row => row.id === data.id)) {
      setRowTransaction(prev => ({
        ...prev,
        add: prev.add.map(row => row.id === data.id ? { ...row, [params.colDef.field]: newValue } : row)
      }));
    } else {
      const existingUpdateIndex = rowTransaction.update.findIndex(row => row.id === data.id);
      
      if (existingUpdateIndex >= 0) {
        setRowTransaction(prev => ({
          ...prev,
          update: prev.update.map(row => 
            row.id === data.id ? { ...row, [params.colDef.field]: newValue } : row
          )
        }));
      } else {
        setRowTransaction(prev => ({
          ...prev,
          update: [...prev.update, { ...data, [params.colDef.field]: newValue }]
        }));
      }
    }
  };

  return {
    rowData,
    setRowData,
    selectedRows,
    setSelectedRows,
    rowTransaction,
    setRowTransaction,
    handleAddRow,
    handleDeleteRow,
    handleSaveRow,
    onCellValueChanged
  };
};

export default useGridTransaction; 